export const SIDE_BAR_WIDTH = '80px';
export const HAMBURGER_BUTTON_SIZE = '40px';
export const HEADER_GAP = '16px';
export const HEADER_HEIGHT_NUMERIC = 67;
export const HEADER_HEIGHT = `${HEADER_HEIGHT_NUMERIC}px`;
export const HEADER_SUBTITLE_GAP = '5px';
export const FEEDBACK_BUTTON_HEIGHT = '52px';
export const FEEDBACK_BUTTON_PADDING = '16px';

export const BACK_BUTTON_STYLES = { padding: '6px', width: 'auto' };
